import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserList from './UserList';
import UserDetail from './UserDetail';
import UserAssignment from './UserAssignment';

const Users: React.FC = () => {
  return (
    <Routes>
      <Route index element={<UserList />} />
      <Route path=":id" element={<UserDetail />} />
      <Route path=":id/assign" element={<UserAssignment />} />
    </Routes>
  );
};

export default Users;